<div class="!h-full">
  @if (!isFirstStop) {
    <div style="width: 1px; margin-right: 1px; margin-left: 1px;"
      [ngClass]="{'!h-full': !!isLastStop, 'bg-primary': !isPedestrian, '!bg-[#AD76F9]': isPedestrian}" [class]="topLineClass ?? defaultClass"
      class="stop-indicator-line h-1/2">
    </div>
  }
  <span [class]="defaultClass" class="stop-indicator"
    [ngClass]="{
        'stop-indicator-rtl-transform': direction === 'rtl',
        'stop-indicator-ltr-transform': direction === 'ltr',
        'stop-indicator--pedestrian': isPedestrian
      }"
  ></span>
  @if (!isLastStop) {
    <div style="width: 1px; margin-right: 1px; margin-left: 1px;"
      [ngClass]="{'!h-full': !!isFirstStop, 'bg-primary': !isPedestrian, '!bg-[#AD76F9]': isPedestrian}" [class]="bottomLineClass ?? defaultClass"
      class="stop-indicator-line h-1/2">
    </div>
  }
</div>